import appState from './schemas/appState/schema.json'
import editorFeatures from './schemas/editorFeatures/schema.json'
import fragmentIndex from './schemas/fragmentIndex/schema.json'

const schemas = {
    AppState: appState,
    EditorFeatures: editorFeatures,
    FragmentIndex: fragmentIndex
}

// todo: remove this export when we have a system to save and retrieve schemas
export {schemas}
